<app-reset-password *ngIf="email !== undefined ; else waiting" [email]="email" [actionCode]="actionCode"></app-reset-password>
<ng-template #waiting>
  <app-loading></app-loading>
</ng-template>